import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import classnames from 'classnames';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';

import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import analytics from 'client/analytics';
import { ANALYTICS_EVENT_CALL_BUTTON } from 'client/analytics/eventList';

import branch from 'client/core/branch';

@branch({
  userAgent: ['analytics', 'userAgent'],
})
class SrContactModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onClickMessage: PropTypes.func,
    onClickCall: PropTypes.func,
    url: PropTypes.string,
    phoneNumber: PropTypes.string,
    userAgent: PropTypes.object.isRequired,
  };

  _onClickMessage = () => {
    const { onClickMessage, url, phoneNumber } = this.props;
    if (onClickMessage) {
      onClickMessage();
    }
    document.location.href = `sms:+1${phoneNumber}?&body=${url} `;
  };

  _onClickCall = () => {
    const { onClickCall, phoneNumber } = this.props;
    analytics.track(ANALYTICS_EVENT_CALL_BUTTON);
    if (onClickCall) {
      onClickCall();
    }
    document.location.href = `tel:+1${phoneNumber}`;
  };

  render() {
    const {
      isOpen,
      onClose,
      userAgent,
    } = this.props;

    if (!isOpen) {
      return null;
    }

    const isMobileApp = isUserAgentMobileApp(userAgent);

    return (
      <Portal>
        <div
          onClick={onClose}
          className={classnames(
            'darkModal',
            'darkNavigator',
            { webview: isMobileApp },
          )}
        >
          <div className='choiceContainer' onClick={preventDefaultPropagation}>
            <div className='choiceGroup'>
              <div className='topLabel'>
                <span>Contact now:</span>
              </div>

              <a className='choice' onClick={this._onClickMessage}>
                <span>Text Message</span>
              </a>

              <a className='choice' onClick={this._onClickCall}>
                <span>Phone Call</span>
              </a>
            </div>
            <div
              className='choice solo'
              onClick={onClose}
            >
              <span>Cancel</span>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrContactModal.displayName = 'SrContactModal';

export default SrContactModal;
